import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'tr-number-badge',
  templateUrl: './number-badge.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberBadgeComponent {
  @Input() public count = 0;
  @Input() public bgClass = 'bg-yellow-500';
  @Input() public showIfZero = false;

  constructor() {}
}
